import React from "react";
import { useSelector } from "react-redux";
import { t } from "i18next";

import useTheme from "../../../../hooks/useTheme";
import { getFeeMatrixForWorkplace } from "../../../../utils/feeFunctions";
import { formatDateRange } from "../../../../utils/helperFunctions";
import { AppPrimaryButton } from "../../../UI/CustomButtons";
import { LightHorizontalDivider } from "../../../UI/CustomElements";
import { AppColumn, AppRow } from "../../../UI/Layouts";
import AppText from "../../../UI/Texts/AppTexts";

export const MobileApplicationCTA = ({ className, style, onClick, jobData }) => {
  const theme = useTheme();
  const feeConfigs = useSelector((state) => state.core.feeConfigs) ?? {};
  const startAt = jobData?.startAt ?? 0;
  const endAt = jobData?.endAt ?? 0;
  const baseFee = jobData?.baseFee?.amount ?? 0;

  const {
    text: compensationText,
    canDisplayCompensation,
    textColor,
    bgColor,
  } = getFeeMatrixForWorkplace({
    baseJobFeeAmount: baseFee,
    workplaceId: jobData?.workplaceDetails?.workPlaceId,
    feeConfigs,
    hourlySuffix: "| h",
  });

  return (
    <div className={className} style={style}>
      <LightHorizontalDivider
        style={{ marginBottom: "0px", color: "transparent" }}
      />
      <div
        style={{
          paddingLeft: theme.spacing.contentElementPadding,
          paddingRight: theme.spacing.contentElementPadding,
          paddingTop: theme.spacing.elementPadding,
          paddingBottom: theme.spacing.elementPadding,
        }}
      >
        <AppRow
          crossAxisAlignment="center"
          mainAxisAlignment="space-between"
          style={{ gap: theme.spacing.elementPadding }}
        >
          <AppColumn
            crossAxisAlignment="start"
            style={{
              flex: 1,
              gap: theme.spacing.elementPaddingSmall,
              minWidth: 0,
            }}
          >
            {canDisplayCompensation && (
              <AppRow
                style={{
                  padding: "4px 10px",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: bgColor,
                  borderRadius: "999rem",
                  width: "fit-content",
                }}
              >
                <AppText.Footnote
                  color={textColor}
                  fontWeight={500}
                  use="strong"
                  margins={{ marginTop: "0px", marginBottom: "0px" }}
                >
                  {compensationText}
                </AppText.Footnote>
              </AppRow>
            )}

            {startAt > 1 && endAt > 1 && (
              <AppText.Footnote
                margins={{ marginTop: "0px", marginBottom: "0px" }}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {formatDateRange(startAt, endAt)}
              </AppText.Footnote>
            )}
          </AppColumn>

          <AppPrimaryButton
            primary
            onClick={onClick}
            size="large"
            style={{
              height: theme.sizing.buttonHeight,
              borderRadius: theme.radius.button,
              flexShrink: 0,
              minWidth: "120px",
            }}
            content={t("jobdetail.application.title")}
          />
        </AppRow>
      </div>
    </div>
  );
};
